import { Component, OnInit,Input } from '@angular/core';
import { FormGroup} from '@angular/forms';
import { SetService } from 'ngx-block-core';
import {  getDayOfYear } from 'date-fns';
@Component({
  selector: 'app-table-form-date',
  templateUrl: './table-form-date.component.html',
  styleUrls: ['./table-form-date.component.less']
})
export class TableFormDateComponent implements OnInit {
  @Input() form: FormGroup;
           
  @Input() ColumnData;
  sets;
  nzFormGroupData;
  
  @Input() blockid="";
  @Input() formId="";
  @Input() columnName="";
  @Input() index=0;
  constructor(public setService: SetService) { }
  
  ngOnInit() {
    this.sets = this.ColumnData['nzBlockSets'];
    this.nzFormGroupData = this.ColumnData['nzFormGroupData'];
    this.today = new Date()
    this.todayday = getDayOfYear(this.today)

  }
  today
  todayday
  months = [];
  disabledDate = (current: Date): boolean => {
    //可用规则
    if (this.sets.datas.nzDisabledDate.available.nzUsed) {
      if (this.sets.datas.nzDisabledDate.available.nzType == 'today') {
        let day = getDayOfYear(current);
        const yearcha = current.getFullYear() - this.today.getFullYear()
        if (yearcha == 1 || yearcha == -1) {
          if (yearcha == 1) {
            day += this.today.getFullYear() % 400 == 0 || (this.today.getFullYear() % 4 == 0 && this.today.getFullYear() % 100 != 0) ? 366 : 365
          } else {
            day -= current.getFullYear() % 400 == 0 || (current.getFullYear() % 4 == 0 && current.getFullYear() % 100 != 0) ? 366 : 365
          }
        } else if (yearcha != 0) {
          return true;
        }
        if (day - this.todayday > this.sets.datas.nzDisabledDate.available.today.after) return true;
        if (this.todayday - day > this.sets.datas.nzDisabledDate.available.today.before) return true;
      } else {
        //范围
        console.log(this.sets.datas.nzDisabledDate.available.range[0])
        let time1 = new Date(this.sets.datas.nzDisabledDate.available.range[0]);
        let time2 = new Date(this.sets.datas.nzDisabledDate.available.range[1]);
        let time = current.getTime();
        if (time < time1.getTime() || time > time2.getTime()) {
          return true;
        }
      }


    }
    //不可用规则
    if (this.sets.datas.nzDisabledDate.range.nzUsed) {
      let time = current.getTime();
      for (let index = 0; index < this.sets.datas.nzDisabledDate.range.data.length; index++) {
        const element = this.sets.datas.nzDisabledDate.range.data[index];
        let time1 = new Date(element[0]);
        let time2 = new Date(element[1]);
        if (time >= time1.getTime() && time <= time2.getTime()) {
          return true;
        }
      }
    }
    //月规则
    if (this.sets.datas.nzDisabledDate.month.nzUsed) {
      for (let index = 0; index < this.sets.datas.nzDisabledDate.month.data.length; index++) {
        const element = this.sets.datas.nzDisabledDate.month.data[index];

        if (current.getDate() == element) return true;
      }
    }
    //周规则
    if (this.sets.datas.nzDisabledDate.week.nzUsed) {
      for (let index = 0; index < this.sets.datas.nzDisabledDate.week.data.length; index++) {
        const element = this.sets.datas.nzDisabledDate.week.data[index];
        if (current.getDay() == element) return true;
      }
    }

    return false;
  };
  disabledDateTime = (): object => {
    return {
      nzDisabledHours: () => this.sets.datas.nzDisabledTime.nzDisabledHours,
      nzDisabledMinutes: () => this.sets.datas.nzDisabledTime.nzDisabledMinutes,
      nzDisabledSeconds: () => this.sets.datas.nzDisabledTime.nzDisabledSeconds
    };
  };

}
